import { render, staticRenderFns } from "./EventDescription.vue?vue&type=template&id=3d1da701&scoped=true&"
import script from "./EventDescription.vue?vue&type=script&lang=ts&"
export * from "./EventDescription.vue?vue&type=script&lang=ts&"
import style0 from "./EventDescription.vue?vue&type=style&index=0&id=3d1da701&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1da701",
  null
  
)

export default component.exports